import { render, staticRenderFns } from "./DotSplitLine.vue?vue&type=template&id=98bd17a2&scoped=true&"
import script from "./DotSplitLine.vue?vue&type=script&lang=js&"
export * from "./DotSplitLine.vue?vue&type=script&lang=js&"
import style0 from "./DotSplitLine.vue?vue&type=style&index=0&id=98bd17a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bd17a2",
  null
  
)

export default component.exports